import { gsap, scrollSmootherInstance } from "./gsap";
import MobileNav from "../components/mobile-nav";
import { throttle } from "lodash";
import barba from '@barba/core';

class Header {
  menuOpen = false;
  isHidden = false;
  scrollTop = 0;
  offset = 50;
  stateClasses = {
    menuOpen: 'menu-open',
    hidden: 'header--hidden',
    transparent: 'header--transparent',
    backlink: 'header--backlink',
  };
  constructor($el) {
    this.$el = $el;
    this.$html = $('html');
    this.$openTrigger = $el.find('[data-header="open"]');
    this.$closeTrigger = $el.find('[data-header="close"]');
    this.$menu = $el.find('[data-header="menu"]');
    this.$backdrop = $el.find('[data-header="backdrop"]');
    this.$mobileNav = $el.find('[data-header="mobile-nav"]');
    this.$breadcrump = $el.find('[data-header="breadcrump"]');
    this.$navLinks = $el.find('[data-header="nav-link"]');
    this.$backlink = $el.find('[data-header="backlink"]');
    this.init();
  }

  init = () => {
    this.$openTrigger.on('click', this.open);
    this.$closeTrigger.on('click', this.close);
    this.$backdrop.on('click', this.close);
    this.$backlink.on('click', this.goBack);

    this.mobileNav = new MobileNav(this.$mobileNav);

    // listen to scroll events
    window.addEventListener('scroll', throttle(this.scrollHandler, 250));
  }

  open = () => {
    // scrollSmootherInstance.scrollTop(0);
    scrollSmootherInstance.paused(true);
    this.$html.addClass(this.stateClasses.menuOpen);
    this.menuOpen = true;
    window.addEventListener('keydown', this.escapeKeyHandler);
  }

  close = () => {
    scrollSmootherInstance.paused(false);
    this.$html.removeClass(this.stateClasses.menuOpen);

    this.menuOpen = false;

    window.removeEventListener('keydown', this.escapeKeyHandler);
  }

  escapeKeyHandler = (e) => {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  updateBreadcrumb = (newText) => {
    this.$breadcrump.text(newText);
  }

  setActiveLink = (id) => {
    this.$navLinks.removeClass('active');
    this.$navLinks.filter(`[data-id="${id}"]`).addClass('active');
  }

  collapseMobileNav = () => {
    this.mobileNav.collapseAll();
  }

  scrollHandler = () => {
    // add class hidden if scrolled down
    if(window.scrollY > this.scrollTop && window.scrollY > this.offset  && !this.isHidden) {
      this.$el.addClass(this.stateClasses.hidden);
      this.isHidden = true;
    } else if(window.scrollY < this.scrollTop && this.isHidden) {
      this.$el.removeClass(this.stateClasses.hidden);
      this.isHidden = false;
    }

    if(window.scrollY <= this.offset && !this.$el.hasClass(this.stateClasses.transparent)) {
      this.$el.addClass(this.stateClasses.transparent);
    } else if(window.scrollY > this.offset && window.scrollY < this.scrollTop && this.$el.hasClass(this.stateClasses.transparent)) {
      this.$el.removeClass(this.stateClasses.transparent);
    }

    this.scrollTop = window.scrollY;
  }

  goBack = (e) => {
    e.preventDefault();
    // check if barba.history.previous is set
    if(barba.history.previous) {
      barba.go(barba.history.previous.url);
    }
  }

  showBacklink = () => {
    this.$el.addClass(this.stateClasses.backlink);
  }

  hideBacklink = () => {
    this.$el.removeClass(this.stateClasses.backlink);
  }

}

export default new Header($('[data-header="el"]'));